module.exports = __webpack_public_path__ + "static/media/brazil_halfglobe.13d1668a.png";